// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "flight-hIzlK";
var _3 = "header__cell-4kpIr";
export { _1 as "__esModule", _2 as "flight", _3 as "header__cell" }
export default { "__esModule": _1, "flight": _2, "header__cell": _3 }
